import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OrderService } from '../../shared/services/order.service';
import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';
registerLocaleData(localeEs);

@Component({
  selector: 'app-order-success',
  templateUrl: './order-success.component.html',
  styleUrls: ['./order-success.component.scss']
})
export class OrderSuccessComponent implements OnInit {
  orderFail: boolean;
  idOrden: number; 
  orden: any;
  fechaEntrega;
  isGuest: boolean = false;
  constructor(
    private router: Router,
    private orderService: OrderService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.idOrden = this.orderService.getSharedId();

    if(this.idOrden !== undefined) {
      if(this.idOrden > 0) {
        this.orderFail = false;
        this.isGuest = false;
          this.orderService.traerOrden(this.idOrden). 
          subscribe( orden => {
            this.orden = orden;
          });
      } else {
        this.orderFail = true;
      }
    } else {
      const id = Number(this.route.snapshot.paramMap.get('id'));
      const guest = this.route.snapshot.paramMap.get('guest');
      if(id > 0) {
        this.idOrden = id;
        this.orderFail = false;
        this.isGuest = true;
          this.orderService.traerOrden(this.idOrden). 
          subscribe( orden => {
            this.orden = orden;
          });
      } else {
        this.orderFail = true;
      }
    }
    
  }

  irAPedidos() {
    this.router.navigateByUrl('/pages/pedidos')
  }
  
  irAComprar() {
    this.router.navigateByUrl('/')
  }

  volver(){
    window. history. back();
  }
}
